import RightSideDetailsPanel from "Areas/SharedFeatures/rightSideDetailsPanelFloat";
import { getObjects } from "Areas/Sidebar/Documents/redux/selectors";
import { connect } from "react-redux";
import actionCreators from "../redux/actionCreators";
import { getActiveDocumentId, getCalculatedDetailedPanelOpen, getSelectedNodesOrEdges } from "../redux/selectors";
const mapStateToProps = (state) => ({
    data: getSelectedNodesOrEdges(state),
    documentId: getActiveDocumentId(state),
    open: getCalculatedDetailedPanelOpen(state),
    documentObjects: getObjects(state)
});
const mapDispatchToProps = (dispatch) => ({
    onChangeOpen: (open) => dispatch(actionCreators.setDetailedPanelOpen(open))
});
export default connect(mapStateToProps, mapDispatchToProps)(RightSideDetailsPanel);
